import api from '../api/axiosInstance';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function registerPushSubscription() {
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service Worker не поддерживается');
  }
  if (!('PushManager' in window)) {
    throw new Error('Push API не поддерживается');
  }
  if (!VAPID_PUBLIC_KEY) {
    throw new Error('VAPID public key не задан');
  }

  const registration =
    (await navigator.serviceWorker.getRegistration()) ??
    (await navigator.serviceWorker.register('/service-worker.js'));

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Пользователь не дал разрешение на уведомления');
  }

  const existingSub = await registration.pushManager.getSubscription();

  const sub =
    existingSub ??
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    }));

  const json = sub.toJSON();

  const body = {
    endpoint: json.endpoint,
    auth: json.keys?.auth,
    p256dh: json.keys?.p256dh,
  };

  if (!body.endpoint || !body.auth || !body.p256dh) {
    throw new Error('Некорректная push-подписка (нет endpoint/auth/p256dh)');
  }

  await api.post('/notifications/subscribe', body);

  return body;
}
